<template>
  <b-modal
    v-model="localShowDetailModal"
    :title="selectedTNA?.course_title || 'Detail Course TNA'"
    size="lg"
    hide-footer
    @hide="$emit('close')"
  >
    <div v-if="isLoadingModal" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="mt-2 text-muted">Loading data...</p>
    </div>
    <div v-if="selectedTNA">
      <div class="row g-0">
        <!-- Full Width - Course Info -->
        <div class="col-md-12">
          <!-- Header Section -->
          <div class="row mb-4">
            <div class="col-md-7 d-flex flex-column justify-content-between">
              <div class="d-flex flex-column">
                <!-- Status Badge -->
                <div class="mb-3">
                  <!-- <span :class="selectedTNA && selectedTNA.is_active ? 'badge bg-success' : 'badge bg-warning'" style="padding: 0.35rem 0.75rem;">
                    <i class="fe fe-info me-1"></i>
                    {{ selectedTNA.status || '-' }}
                  </span> -->
                  <b-badge
                    :variant="getStatusVariant(selectedTNA.status)"
                    class="completion-badge"
                  >
                    {{ getApprovalStatusLabel(selectedTNA.status) }}
                  </b-badge>
                </div>
                <ApprovalStepper :item="selectedTNA" />

                <!-- Course Title -->
                <h3 class="mb-3 font-weight-bold" style="color: #1a202c">
                  {{ selectedTNA.title || "-" }}
                </h3>
              </div>

              <!-- Stats -->
              <div class="row p-3 rounded" style="background-color: #fafafa">
                <div class="col-4">
                  <div class="d-flex align-items-center text-muted">
                    <i class="fe fe-clock me-2" style="font-size: 1.1rem"></i>
                    <div>
                      <small class="d-block" style="font-size: 0.7rem"
                        >Learning Hours</small
                      >
                      <strong class="text-dark"
                        >{{
                          selectedTNA.hour ? Number(selectedTNA.hour) : "-"
                        }}
                        hrs</strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="d-flex align-items-center text-muted">
                    <i
                      class="fe fe-dollar-sign me-2"
                      style="font-size: 1.1rem"
                    ></i>
                    <div>
                      <small class="d-block" style="font-size: 0.7rem"
                        >Estimated Price</small
                      >
                      <strong class="text-dark"
                        >{{ selectedTNA?.price && selectedTNA?.currency ? `${selectedTNA.currency} ${selectedTNA.price}` : "-" }}</strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="d-flex align-items-center text-muted">
                    <i
                      class="fe fe-currency me-2"
                      style="font-size: 1.1rem"
                    ></i>
                    <div>
                      <small class="d-block" style="font-size: 0.7rem"
                        >Currency</small
                      >
                      <strong class="text-dark">{{
                        selectedTNA.currency
                      }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Side - Course Image -->
            <div class="col-md-5">
              <img
                :src="
                  selectedTNA && selectedTNA.cover_image_path
                    ? `${selectedTNA.cover_image_path}`
                    : `https://dummyimage.com/300x200/FAFAFA/000000&text=${
                        selectedTNA.title || 'Course'
                      }`
                "
                alt="Course Thumbnail"
                class="w-100 rounded"
                style="height: 280px; object-fit: cover"
              />
            </div>

            <!-- Tabs -->
            <ul class="nav nav-tabs mb-3" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  data-bs-toggle="tab"
                  href="#description"
                >
                  Description
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#attributes">
                  Attributes
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#platform">
                  Platform
                </a>
              </li>
            </ul>

            <!-- Tab Content -->
            <div class="tab-content">
              <!-- Description Tab -->
              <div class="tab-pane fade show active" id="description">
                <p class="mb-3" style="line-height: 1.8; font-size: 0.9rem">
                  {{ selectedTNA.description || "No description available." }}
                </p>
              </div>
              <!-- Attribute Tab -->
              <div class="tab-pane fade" id="attributes">
                <div class="row">
                  <!-- Left Column -->
                  <div class="col-md-6">
                    <!-- Course Method -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Course Method</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.method?.name || "-" }}
                      </p>
                    </div>

                    <!-- Course Category -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2"
                        >Course Category</label
                      >
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.category?.title || "-" }}
                      </p>
                    </div>

                    <!-- Course URL -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Course URL</label>
                      <div class="d-flex align-items-center gap-2">
                        <a
                          v-if="selectedTNA.website"
                          :href="selectedTNA.website"
                          target="_blank"
                          class="text-primary text-truncate"
                          style="max-width: 80%; text-decoration: none"
                        >
                          {{ selectedTNA.website }}
                        </a>
                        <span v-else class="text-muted">-</span>
                        <a
                          v-if="selectedTNA.website"
                          :href="selectedTNA.website"
                          target="_blank"
                          class="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                          style="
                            width: 32px;
                            height: 32px;
                            padding: 0;
                            border-radius: 4px;
                          "
                        >
                          <i class="fe fe-send" style="font-size: 14px"></i>
                        </a>
                      </div>
                    </div>

                    <!-- Department -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Department</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA.department || "-" }}
                      </p>
                    </div>

                    <!-- Division -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Division</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA.division || "-" }}
                      </p>
                    </div>
                  </div>

                  <!-- Right Column -->
                  <div class="col-md-6">
                    <!-- Course Type -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Course Type</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.type?.name || "-" }}
                      </p>
                    </div>

                    <!-- Course Scope -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Course Scope</label>
                      <div>
                        <span
                          v-for="scope in selectedTNA.training_scope"
                          :key="scope"
                          class="badge badge-dark font-weight-bold mr-1"
                        >
                          {{ scope }}
                        </span>
                      </div>
                    </div>

                    <!-- STEM Category -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">STEM Category</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA.stem_category || "-" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Platform Tab -->
              <div class="tab-pane fade" id="platform">
                <div class="row">
                  <!-- Left Column -->
                  <div class="col-md-6">
                    <!-- Platform Name -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Platform Name</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA.platform || "-" }}
                      </p>
                    </div>

                    <!-- Training Provider (LDP) -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2"
                        >Training Provider</label
                      >
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.provider?.name || "-" }}
                      </p>
                    </div>

                    <!-- Provider Website -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2"
                        >Provider Website</label
                      >
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA.website || "-" }}
                      </p>
                    </div>

                    <!-- Email -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Email</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.provider?.email || "-" }}
                      </p>
                    </div>
                  </div>

                  <!-- Right Column -->
                  <div class="col-md-6">
                    <!-- Provider Name (LSP) -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2"
                        >Provider Name (LSP)</label
                      >
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.lsp?.name || "-" }}
                      </p>
                    </div>

                    <!-- Address -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Address</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.provider?.address || "-" }}
                      </p>
                    </div>

                    <!-- Contact Person -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2"
                        >Contact Person</label
                      >
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.provider?.contact_person || "-" }}
                      </p>
                    </div>

                    <!-- Phone -->
                    <div
                      class="mb-4 py-2 px-3 rounded"
                      style="background-color: #fafafa"
                    >
                      <label class="text-muted small mb-2">Phone</label>
                      <p class="text-dark font-weight-bold mb-0">
                        {{ selectedTNA?.provider?.phone || "-" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ApprovalStepper from "@/components/ApprovalStepper.vue";
import { getApprovalStatusLabel } from "@/utils/approvalStatus";

export default {
  name: "DetailTNA",
  components: { ApprovalStepper },
  props: {
    showDetailModal: {
      type: Boolean,
      default: false,
    },
    isLoadingModal: {
      type: Boolean,
      default: false,
    },
    selectedTNA: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    localShowDetailModal: {
      get() {
        return this.showDetailModal;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    getApprovalStatusLabel,
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    getStatusVariant(status) {
      switch (status) {
        case "approved":
        case "completed":
          return "success";
        case "rejected":
          return "danger";
        case "approval_manager":
        case "approval_hse":
        case "approval_hr":
        case "pending":
          return "warning";
        default:
          return "secondary";
      }
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
